var map = {
	"./Co.Durham2hrRapidResponseNursingTeamsGeneralGuidanceonRapidResponseNursingServices.jpg": 3705,
	"./DMHSDEC(MedicalandSurgicalunit)SDECguidanceforambulanceclinicians.jpg": 3706,
	"./Darlington2hrRapidResponseNursingTeamGeneralGuidanceonRapidResponseNursingServices.jpg": 3707,
	"./Gateshead2hrRapidResponseNursingTeamGeneralGuidanceonRapidResponseNursingServices.jpg": 3708,
	"./JCUHSDEC(MedicalandSurgicalunit)SDECguidanceforambulanceclinicians.jpg": 3709,
	"./NEAS0002.34I-35161_-20424_0.jpg": 3710,
	"./NEAS0002.34I-35167_-20420_0.jpg": 3711,
	"./NEAS0003.34I-35633_-20728_0.jpg": 3712,
	"./NEAS0004.34I-38773_-22690_0.jpg": 3713,
	"./NEAS0006.34I-43085_-25762_0.jpg": 3714,
	"./NEAS0440.34I-35092_-20078_0.jpg": 3715,
	"./NEAS0444.34I-36212_-21262_0.jpg": 3716,
	"./NEAS0444.34I-36299_-21312_0.jpg": 3717,
	"./NEAS0450.34I-35094_-20109_0.jpg": 3718,
	"./NEAS0460.34I-35095_-20110_0.jpg": 3719,
	"./NEAS0480.34I-36624_-21522_0.jpg": 3720,
	"./NEAS0480.34I-36624_-21523_0.jpg": 3721,
	"./NEAS0480.34I-36624_-21525_0.jpg": 3722,
	"./NEAS0480.34I-36624_-21526_0.jpg": 3723,
	"./NEAS0480.34I-36624_-21527_0.jpg": 3724,
	"./NEAS0480.34I-36624_-21528_0.jpg": 3725,
	"./NEAS0480.34I-36624_-21529_0.jpg": 3726,
	"./NEAS0480.34I-36624_-21530_0.jpg": 3727,
	"./NEAS0490.34I-37203_-22043_0.jpg": 3728,
	"./NEAS0570.34I-37752_-22114_0.jpg": 3729,
	"./NEAS0590.34I-38052_-22425_0.jpg": 3730,
	"./NEAS0590.34I-38052_-22429_0.jpg": 3731,
	"./NEAS0590.34I-38054_-22426_0.jpg": 3732,
	"./NEAS0600.34I-38119_-22432_0.jpg": 3733,
	"./NEAS0610.34I-38115_-22428_0.jpg": 3734,
	"./NEAS0620.34I-38118_-22430_0.jpg": 3735,
	"./NEAS0630.34I-38374_-22557_0.jpg": 3736,
	"./NEAS0630.34I-38374_-22558_0.jpg": 3737,
	"./NEAS0650.34I-39295_-23327_0.jpg": 3738,
	"./NEAS0670.34I-40919_-24211_0.jpg": 3739,
	"./NEAS0888.34I-35130_-20425_0.jpg": 3740,
	"./NEAS0888.34I-35137_-20229_0.jpg": 3741,
	"./NEAS0888.34I-35137_-20230_0.jpg": 3742,
	"./NSECHSDEC(Medical,SurgicalandGynaeUnit)SDECguidanceforambulanceclinicians.jpg": 3743,
	"./NSECHStrokePathwayStroke.jpg": 3744,
	"./Newcastle2hrRapidResponseNursingTeamGeneralGuidanceonRapidResponseNursingServices.jpg": 3745,
	"./NewcastleChest(COPD)TeamNEAS-CHESTReferralPathway-updated2019.jpg": 3746,
	"./NorthTees+Hartlepool2hrRapidResponseNursingTeamNT_and_ST_RRNT.jpeg": 3747,
	"./NorthTeesHospital-SDEC(EAU)SDECguidanceforambulanceclinicians.jpg": 3748,
	"./QESDECSDECguidanceforambulanceclinicians.jpg": 3749,
	"./RVISDECSDECguidanceforambulanceclinicians.jpg": 3750,
	"./SouthTees2hrRapidResponseNursingTeamNT_and_ST_RRNT.jpeg": 3751,
	"./SouthTyneside2hrRapidResponseNursingTeamGeneralGuidanceonRapidResponseNursingServices.jpg": 3752,
	"./SouthTynesideSDECSDECguidanceforambulanceclinicians.jpg": 3753,
	"./Sunderland2hrRapidResponseNursingTeam(R@H)GeneralGuidanceonRapidResponseNursingServices.jpg": 3754,
	"./SunderlandSDEC(MedicalandSurgicalunit)SDEC.jpg": 3755,
	"./UHNDSDECSDECguidanceforambulanceclinicians.jpg": 3756,
	"./UrgentTreatmentCentre-CountyDurhamUECNUTCClinicianComms(1).jpg": 3757,
	"./UrgentTreatmentCentre-DarlingtonUECNUTCClinicianComms(1).jpg": 3758,
	"./UrgentTreatmentCentre-NewcastleUECNUTCClinicianComms(1).jpg": 3759,
	"./UrgentTreatmentCentre-NorthTeessideUECNUTCClinicianComms(1).jpg": 3760,
	"./UrgentTreatmentCentre-NorthTynesideUECNUTCClinicianComms(1).jpg": 3761,
	"./UrgentTreatmentCentre-NorthumberlandUECNUTCClinicianComms(1).jpg": 3762,
	"./UrgentTreatmentCentre-SouthTeessideUECNUTCClinicianComms(1).jpg": 3763,
	"./UrgentTreatmentCentre-SunderlandUECNUTCClinicianComms(1).jpg": 3764,
	"./VascularPathwayVascularBypassGuidance2.jpg": 3765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3704;